












import { Component, Prop, Vue } from 'vue-property-decorator'

import { VuesaxLoadingTypes } from '@/shims-vuesax'

@Component
export default class VsLoading extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly contained!: boolean

  @Prop({ type: String, default: 'default' })
  readonly type!: VuesaxLoadingTypes
}
